<app-admin-layout [title]="title" [subtitle]="subtitle" [contentsPath]='contentsPath'
  [contentId]='contentId' [showContentHeader]='showContentHeader'></app-admin-layout>